module.exports = __webpack_public_path__ + "img/cl.4d2a6ff9.svg";